import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import classnames from 'classnames';
import { Body, Tooltip, PromoChip, CounterChip } from '@cognite/cogs-core';
import { InfoFilledIcon } from '@cognite/cogs-icons';
import { IconWrapper } from '@cognite/cogs-utils';
import { useIsOverflowing } from '../../hooks/use-is-overflowing.js';

var ActionListItemChildren = function ActionListItemChildren(_ref) {
  var children = _ref.children,
    inverted = _ref.inverted,
    icon = _ref.icon,
    promoChipOptions = _ref.promoChipOptions,
    counterChipOptions = _ref.counterChipOptions,
    textOverflowTooltipOptions = _ref.textOverflowTooltipOptions,
    infoTooltipOptions = _ref.infoTooltipOptions,
    trailingContent = _ref.trailingContent;
  var _a;
  var _b = promoChipOptions || {},
    promoChipLabel = _b.label,
    otherPromoChipProps = __rest(_b, ["label"]);
  var itemTextRef = useRef(null);
  var isItemTextOverflowing = useIsOverflowing(itemTextRef);
  return jsxs(Fragment, {
    children: [jsxs(Body, {
      size: "medium",
      strong: true,
      as: "span",
      className: classnames('cogs-lab', 'cogs-actionlist-item__content'),
      noOfLines: 1,
      children: [icon && jsx(IconWrapper, {
        size: 16,
        className: classnames('cogs-lab', 'cogs-actionlist-item__icon'),
        children: icon
      }), jsx("span", {
        ref: itemTextRef,
        className: classnames('cogs-lab', 'cogs-actionlist-item__text'),
        children: jsx(Tooltip, Object.assign({
          content: children,
          disabled: !isItemTextOverflowing
        }, textOverflowTooltipOptions, {
          children: children
        }))
      }), isItemTextOverflowing && '...', infoTooltipOptions && jsx(Tooltip, Object.assign({}, infoTooltipOptions, {
        children: jsx(IconWrapper, {
          "aria-label": typeof infoTooltipOptions.content === 'string' ? infoTooltipOptions.content : '',
          tabIndex: 0,
          className: classnames('cogs-lab', 'cogs-actionlist-item__info-icon'),
          size: 12,
          children: jsx(InfoFilledIcon, {})
        })
      }))]
    }), !!trailingContent || !!promoChipOptions || !!counterChipOptions ? jsxs("span", {
      className: classnames('cogs-lab', 'cogs-actionlist-item__trailing-content'),
      children: [promoChipOptions && jsx(PromoChip, Object.assign({
        "aria-label": promoChipLabel,
        dense: true
      }, otherPromoChipProps, {
        children: promoChipLabel
      })), counterChipOptions && jsx(CounterChip, Object.assign({
        "aria-label": counterChipOptions.label || ((_a = counterChipOptions.counter) === null || _a === undefined ? undefined : _a.toString()) || '',
        inverted: inverted
      }, counterChipOptions)), trailingContent]
    }) : jsx(Fragment, {})]
  });
};

export { ActionListItemChildren };
